import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEmploymentDurationPage = {
  alert: {
    error: 'coapplicant-employment-duration-page.form.alert.error',
  },
  footer: {
    root: 'coapplicant-employment-duration-page.footer.root',
  },
  form: {
    h1: 'coapplicant-employment-duration-page.form.h1',
    h2: 'coapplicant-employment-duration-page.form.h2',
    radioGroupRoot:
      'coapplicant-employment-duration-page.form.radio-group-root',
    radioOption1: 'coapplicant-employment-duration-page.form.radio-option1',
    radioOption2: 'coapplicant-employment-duration-page.form.radio-option2',
    root: 'coapplicant-employment-duration-page.form.root',
    submitButton: 'coapplicant-employment-duration-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
